import React from "react";

export default function Graph_D3() {
  return (
    <div>
      <h1>Graph_D3</h1>
      <p>This is the Graph_D3 component.</p>
    </div>
  );
}
